import DeliveryPreference from './delivery-preference.component'

export default DeliveryPreference
